export default class Action {
}
